<template>
  <div
    style="display: flex; align-items: center; justify-content: center; height: 100vh; width: 100vw; background-color: #1E355C;"
  >
    <img
      :src="splash"
      alt="Dogs For Our Brave"
      style="width: 100%; height: 100%; object-fit: contain;"
    />
  </div>
</template>

<script>
// import splash2 from "@/assets/dfob-company-logo.svg";
import splash from "@/assets/splash.png";

export default {
  name: "SplashImage",
  data() {
    return {
      splash,
    };
  },
};
</script>
